/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import { Link } from "react-router-dom";
import { useRef } from "react";

function BaseNavbarLink({
  name,
  routes = false,
  openHandler = false,
  closeHandler = false,
  children = false,
  collapseStatus = false,
  light = false,
  ...rest
}) {

  const linkRef = useRef(null);

  // console.log(name, routes, children);
  const has_dropdown = routes.length > 0 && typeof routes[0].collapse != 'undefined' && routes[0].collapse.length > 0;

  return (
    <>
      {
        has_dropdown ? (
          <>
            <SoftBox
              {...rest}
              mx={{ xl: 0.25, xxl: 1, x3l: 3 }}
              p={1}
              ref={linkRef} // Attach the ref to the SoftBox
              onMouseEnter={!children ? () => {
                // Instead of passing an event, pass the actual DOM node
                if (openHandler) openHandler(linkRef.current);
              } : undefined}
              onMouseLeave={!children ? closeHandler : undefined}
              display="flex"
              alignItems="center"
              color={light ? "white" : "dark"}
              sx={{ cursor: "pointer", userSelect: "none" }}
            >
              <SoftTypography
                variant="body2"
                fontWeight="regular"
                textTransform="capitalize"
                color="inherit"
                sx={{ fontWeight: "100%" }}
              >
                {name.replace("_", " ")}
              </SoftTypography>
              <SoftTypography variant="body2" color={light ? "white" : "dark"}>
                <Icon sx={{ fontWeight: "bold", verticalAlign: "middle" }}>keyboard_arrow_down</Icon>
              </SoftTypography>
            </SoftBox>
            <Collapse in={Boolean(collapseStatus)} timeout="auto" unmountOnExit>
              {children}
            </Collapse>
          </>
        ) : (
          <SoftBox
            {...rest}
            mx={{ xl: 0.25, xxl: 1, x3l: 3 }}
            p={1}
            component={Link}
            to={routes[0].route}
            display="flex"
            alignItems="center"
            color={light ? "white" : "dark"}
            sx={{ cursor: "pointer", userSelect: "none", textDecoration: "none" }}
          >
            <SoftTypography
              variant="body2"
              fontWeight="regular"
              textTransform="capitalize"
              color="inherit"
              sx={{ fontWeight: "100%" }}
            >
              {name.replace("_", " ")}
            </SoftTypography>
          </SoftBox>
        )
      }
    </>
  );
}


// Typechecking props for the BaseNavbarLink
BaseNavbarLink.propTypes = {
  name: PropTypes.string.isRequired,
  routes: PropTypes.arrayOf(PropTypes.object).isRequired,
  openHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  closeHandler: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  children: PropTypes.node,
  collapseStatus: PropTypes.bool,
  light: PropTypes.bool,
};

export default BaseNavbarLink;
